import { Core, JsonLd } from '../../Constants';
import ExpansionModelBuilder from './ExpansionModelBuilder';
export function Mixin(Base) {
    class ExplicitRepresentationExpansion extends Base {
        mapShorthandValue(value) {
            return `"${value}"`;
        }
        mapExpandedValue(value) {
            if (value['@id']) {
                return value['@id'];
            }
            if (value['@language']) {
                return `"${value['@value']}"@${value['@language']}`;
            }
            if (value['@type']) {
                return `"${value['@value']}"^^${value['@type']}`;
            }
            return `"${value['@value']}"`;
        }
    }
    return ExpansionModelBuilder(ExplicitRepresentationExpansion);
}
export function shouldApply(resource) {
    const isTemplate = resource.types.contains(Core.Vocab('IriTemplate'));
    const isUndefined = typeof resource[Core.Vocab('variableRepresentation')] === 'undefined' ||
        resource[Core.Vocab('variableRepresentation')] === null;
    const isExactMatch = resource[Core.Vocab('variableRepresentation')] &&
        resource[Core.Vocab('variableRepresentation')][JsonLd.Id] === Core.Vocab('ExplicitRepresentation');
    return isTemplate && (!isUndefined && isExactMatch);
}
//# sourceMappingURL=ExplicitRepresentationExpansion.js.map